/**
 * Hand the browser a blob to SAVE (F-135 download). One mechanism for both
 * shells: an `<a download>` on a same-origin blob URL is honoured everywhere
 * Kola runs — a browser tab saves to its downloads folder, and inside the
 * desktop app Chromium raises the session's `will-download`, which the app
 * already answers with the OS save dialog and a "Download complete" notice.
 *
 * A blob rather than a link to the asset route on purpose: the embedded shell
 * has no cookie for the Kola origin (its identity is a Bearer header the
 * fetch carries), and Chromium ignores `download` on a cross-origin link
 * anyway — so the bytes are fetched through the authenticated channel first.
 */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = "noopener";
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Revoked LATER: revoking synchronously can cancel the save in some
  // browsers before the download has claimed the bytes.
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
